var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_vm._m(0),_c('router-view')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"nav"}},[_c('div',{staticClass:"logo"},[_c('img',{attrs:{"alt":"Our Logo","src":"/images/logo.png"}}),_c('img',{attrs:{"alt":"betterway","src":"/images/logo-name.png"}})]),_c('h1',[_vm._v("המערכת שמנהלת לך את דוחות החניה")])])
}]

export { render, staticRenderFns }